<script setup>
    import { onMounted } from "vue";
    import { useRouter } from 'vue-router';
    import { useAuthStore } from '../../stores/auth';
    import useUser from '@/composables/user';

    import axios from "axios";

    const router = useRouter();
    const auth = useAuthStore();
    const { clearToken } = useUser();

    onMounted(() => {
        axios.post('/api/v1/logout')
            .finally(function () {
                clearToken();
                auth.removeLoggedIn();
                router.push({ name: 'welcome'});
            });
    });

</script>
